import {call, put} from "redux-saga/effects";
import {requestPaymentSearch, requestPaymentVerification} from "../requests/paymentVerificationService";
import {setLoading, setError, setPaymentList, setProcessing} from "../../slices/paymentVerificationSlice";
import {toast} from "react-toastify";
import {setSuccess} from "../../slices/paymentVerificationSlice";


function* handlePaymentSearch(action) {
  try {
    yield put(setLoading())
    const response = yield call(() => requestPaymentSearch(action.payload))
    yield put(setPaymentList(response.data["data"]))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}

function* handlePaymentVerification(action) {
  const {paymentItemId, verificationPayload} = action.payload
  try {
    yield put(setProcessing())
    yield call(() => requestPaymentVerification(verificationPayload))
    yield put(setSuccess({payload: paymentItemId}))
    toast.success("Transaction verified successfully!")
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  }
}

export {handlePaymentSearch, handlePaymentVerification}